export const formConstants = {
  Mode: {
    CREATE: "Create",
    EDIT: "Edit/View",
    VIEW: "VIEW",
    DELETE: "Delete",
    OR: "OR",
    AND: "AND"
  }
};

export const codeTypes = {
  URL: "url",
  GS1: "gs1",
  APP: "appLink",
  CALL: "tel",
  EMAIL: 'mailto',
  EVENT: 'vevent',
  MINILANDINGPAGE: 'html5',
  MENULITE: "menulite",
  NOTE: "note",
  SMS: "sms",
  MOBILEWALLET: "passpage",
  SKYPE: "skype",
  VCARD: "vcard",
  WHATSAPP: "wa",
  WIFI: "wifi",
  ZOOM: 'zoom',
  SocialMedia: "socialMedia",
  MEDIAFILE: "mediafile"
}
export const codeBehavior = {
  STATIC: "STATIC",
  DYNAMIC: "DYNAMIC"
}

export const codeTypesWithBehavior = {
  URL: codeTypes.URL + "|" + codeBehavior.DYNAMIC,
  APP: codeTypes.APP + "|" + codeBehavior.DYNAMIC,
  CALL: codeTypes.CALL + "|" + codeBehavior.DYNAMIC,
  EMAIL: codeTypes.EMAIL + "|" + codeBehavior.DYNAMIC,
  EVENT: codeTypes.EVENT + "|" + codeBehavior.DYNAMIC,
  MINILANDINGPAGE: codeTypes.MINILANDINGPAGE + "|" + codeBehavior.DYNAMIC,
  NOTE: codeTypes.NOTE + "|" + codeBehavior.DYNAMIC,
  SMS: codeTypes.SMS + "|" + codeBehavior.DYNAMIC,
  MOBILEWALLET: codeTypes.MOBILEWALLET + "|" + codeBehavior.DYNAMIC,
  SKYPE: codeTypes.SKYPE + "|" + codeBehavior.DYNAMIC,
  VCARD: codeTypes.VCARD + "|" + codeBehavior.DYNAMIC,
  WHATSAPP: codeTypes.WHATSAPP + "|" + codeBehavior.DYNAMIC,
  WIFI: codeTypes.WIFI + "|" + codeBehavior.DYNAMIC,
  ZOOM: codeTypes.ZOOM + "|" + codeBehavior.DYNAMIC,
  SocialMedia: codeTypes.SocialMedia + "|" + codeBehavior.DYNAMIC,
  MENULITE: codeTypes.MENULITE + "|" + codeBehavior.DYNAMIC,
  MEDIAFILE: codeTypes.MEDIAFILE + "|" + codeBehavior.DYNAMIC,
}

export const Roles = {
  VIEW: "VIEW",
  DRAFT: "DRAFT",
  PUBLISH: "PUBLISH",
  BATCH: "BATCH",
  ADVANCED: "ADVANCED",
  ANALYTICS: "ANALYTICS",
  ALL: "ALL",
}

const CODE_MANAGE_SET = [Roles.DRAFT, Roles.PUBLISH, Roles.BATCH, Roles.ALL]
const BATCH_MANAGE_SET = [Roles.BATCH, Roles.ALL]
const ANALYTICS_MANAGE_SET = [Roles.ANALYTICS, Roles.ALL]
export const ADVANCED_SETTINGS_MANAGE_SET = [Roles.ADVANCED, Roles.ALL]
export const CODE_PUBLISH_SET = [Roles.PUBLISH,Roles.BATCH, Roles.ALL]
const withViewRole = (roles) => [Roles.VIEW, ...roles];

export const RoleSet = { //TODO: Maybe move this to db?
  viewCode: withViewRole(CODE_MANAGE_SET),
  createCode: CODE_MANAGE_SET,
  editCode: CODE_MANAGE_SET,
  deleteCode: CODE_MANAGE_SET,
  simulateCode: CODE_MANAGE_SET,
  viewQrDesign: withViewRole(ADVANCED_SETTINGS_MANAGE_SET),
  qrDesigner: ADVANCED_SETTINGS_MANAGE_SET,
  editQrDesign: ADVANCED_SETTINGS_MANAGE_SET,
  createParameterSet: ADVANCED_SETTINGS_MANAGE_SET,
  editParameterSet: ADVANCED_SETTINGS_MANAGE_SET,
  viewParameterSet: withViewRole(ADVANCED_SETTINGS_MANAGE_SET),
  viewRuleSet: withViewRole(ADVANCED_SETTINGS_MANAGE_SET),
  createRuleSet: ADVANCED_SETTINGS_MANAGE_SET,
  editRuleSet: ADVANCED_SETTINGS_MANAGE_SET,
  viewTag: withViewRole(ADVANCED_SETTINGS_MANAGE_SET),
  createTag: ADVANCED_SETTINGS_MANAGE_SET,
  editTag: ADVANCED_SETTINGS_MANAGE_SET,
  deleteTag: ADVANCED_SETTINGS_MANAGE_SET,
  viewUtm: withViewRole(ADVANCED_SETTINGS_MANAGE_SET),
  createUtm: ADVANCED_SETTINGS_MANAGE_SET,
  editUtm: ADVANCED_SETTINGS_MANAGE_SET,
  reports: ANALYTICS_MANAGE_SET,
  superset: ANALYTICS_MANAGE_SET,
  batches: BATCH_MANAGE_SET,
  batchItems: BATCH_MANAGE_SET,
  "/data/exports": withViewRole(ANALYTICS_MANAGE_SET),
  "/data/exports/create": withViewRole(ANALYTICS_MANAGE_SET),
  "/data/exports/edit/:id": withViewRole(ANALYTICS_MANAGE_SET),
  "/data/exports/delete/:id": withViewRole(ANALYTICS_MANAGE_SET),
  createMediaFile: ADVANCED_SETTINGS_MANAGE_SET,
  editMediaFile: ADVANCED_SETTINGS_MANAGE_SET,
  viewMediaFile: withViewRole(ADVANCED_SETTINGS_MANAGE_SET),
}

export const MergedRoutes = new Map([ // map of routes which have edit and view in same component
  ['editCode', 'viewCode'],
  ['editQrDesign', 'viewQrDesign'],
  ['editParameterSet','viewParameterSet'],
  ['editRuleSet','viewRuleSet'],
  ['editTag','viewTag'],
  ['editUtm','viewUtm'],
  ['editMediaFile', 'viewMediaFile'],
]);


export const batchTypesConstatns = {
  CREATE: "Create",
  DOWNLOAD: "Download",
  EDIT: "Edit"
}

export const batchEditTypes = {
  URL: "Url",
  STATUS: "Status",
  TAG: "Tag",
  OTHERS: "Others"
}

export const batchEditTag = {
  ADD_TAG: "Add",
  REPLACE_TAG: "Replace",
  REMOVE_TAG: "Remove"
}

export const batchEditAdvancedConfigs = {
  UTM: "UTM",
  PARAMETERS: "Parameters",
  RULES: "Rules",
  STATUS: "Status",
  DESIGNER_QR: "Designer QR",
  EXTENDED_DATA: "Extended Data",
  RULE_SET: "Rule Set"  // This is using for batch rule model
}

export const codeStatus = {
  COMPLETED: "Completed",
  PAUSED: "Paused",
  PUBLISHED: "Published"
}

export const deliveryTypes = {
  S3: 's3',
  EMAIL: 'email'
}

export const selectedBatchCreateCodetype = {
  GS1: "gs1",
  URL: "url",
}

export const imageFileTypes = {
  PNG:"png",
  JPEG:"jpeg",
  BMP:"bmp",
  GIF:"gif",
  TIFF:["tiff", "tif"],
  SVG:["svg","svg+xml"],
  EPS:["eps","postscript"]
}
export const nonImageFileTypes = {
  MP3: "mp3",
  MP4: "mp4",
  WAV: "wav",
  MOV: "mov",
  DOC: "doc",
  DOCX: "docx",
  XLS: "xls",
  XLSX: "xlsx",
  CSV: "csv",
  TXT: "txt",
  PPT: "ppt",
  PPTX: "pptx",
  PDF: "pdf",
  JSON: "json",
  HTML: "html",
  XML: "xml"
};

export const filterSessionConstants = {
  CONFIG_SESSION_STORAGE_KEY: "configFilters",
  CODE_SESSION_STORAGE_KEY: "codeListFilters",
}

export const fileSizeConstants = {
  MAX_UPLOAD_QR_IMAGE: 2000000, // 2MB
  MAX_UPLOAD_CONTENT_FILE: 200000000, // 200MB
};

export const permissionWarningConstant = {
  MESSAGE: "You don’t have permission to access this feature. Contact an administrator if you need your permissions updated",
}
export const uriPatternConstants = {
  DEFAULT_SHORT_URI_PATTERN: '^[a-zA-Z0-9\\-,=@/_]+$'
};

export const protocolConstants = {
  HTTP: "http://",
  HTTPS: "https://"
};

export const protocolLabels = {
  [protocolConstants.HTTP]: "HTTP",
  [protocolConstants.HTTPS]: "HTTPS",
};

// Default placeholder value used for QR preview and v1 image configs
export const DEFAULT_QR_PLACEHOLDER = "Th1s 1s @ s@mpl3 QR v@lu3";
export const barcodeFormatConstants = {
  QR_CODE: "QR_CODE",
  DATA_MATRIX: "DATA_MATRIX",
};

// Module width constraints based on unit of measure
export const MODULE_WIDTH_CONSTRAINTS = {
  inch: { min: 0.015, max: 0.125, step: 0.001 },
  cm: { min: 0.038, max: 0.340, step: 0.001 },
  mm: { min: 0.38, max: 3.40, step: 0.01 }
};

// Size constraints based on unit of measure
export const SIZE_CONSTRAINTS = {
  inch: { min: 0.35, max: 5, step: 0.01 },
  cm: { min: 0.89, max: 12.7, step: 0.01 },
  mm: { min: 8.9, max: 127, step: 0.1 }
};

export const BWR_CONSTRAINTS = {
  inch: { min: 0.0010, max: 0.0100, step: 0.0001 },
  cm: { min: 0.0025, max: 0.0254, step: 0.0001 },
  mm: { min: 0.025, max: 0.254, step: 0.001 }
};

export const DECIMAL_LIMITS = {
  size : {
    name: "size",
    inch: 3,
    cm: 3,
    mm: 3
  },
  moduleWidth: {
    name: "moduleWidth",
    inch: 3,
    cm: 3,
    mm: 3
  },
  bwr: {
    name: "bwr",
    inch: 4,
    cm: 4,
    mm: 3
  }
};

export const PREVIEW_IMAGE_SIZE = {
  size: 0.35,
  resolution: 300,
  unit: "inch"
};

export const SUPPORTED_REDSHIFT_AGGREGATE_FUNCTIONS = ["ANY_VALUE", "AVG", "COUNT", "LISTAGG", "MAX", "MEDIAN", "MIN", "SUM"];
export const QUERY_AGGREGATE_RX = new RegExp(`\\b(${SUPPORTED_REDSHIFT_AGGREGATE_FUNCTIONS.join('|')})\\b`, 'g');

export const QUERY_TIMEPERIOD_RX = new RegExp("\\b(WEEK|MONTH|QUARTER|YEAR) FROM TO_DATE\\b|DATE_TRUNC\\('hour'", "g");
